// extracted by mini-css-extract-plugin
export default {"NewAreaButton":"Buttons_NewAreaButton__cDvfS","RemoveAreaButton":"Buttons_RemoveAreaButton__5kYJY"};